module.exports = __webpack_public_path__ + "static/media/home-grid-item-3.f9002435.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/home-grid-item-3.png
// module id = 512
// module chunks = 0